var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{staticClass:"w-100",staticStyle:{"height":"40px","background":"#3b51d5"},attrs:{"toggleable":"lg","type":"dark","sticky":""}}),_vm._v(" "),_c('Nuxt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }